import { LoadingButton } from '@mui/lab';
import { styled } from '@mui/material';

export const PrimaryButton = styled(LoadingButton)({
  padding: '4px 10px',
  gap: '8px',
  height: '36px',
  backgroundColor: '#0675DD',
  color: '#FFFFFF',
  borderRadius: '4px',
  textTransform: 'none',
  fontSize: '14px',
  '&:hover': {
    backgroundColor: '#0650A9'
  },
  '&:disabled': {
    backgroundColor: '#B0B0B0',
    color: '#FFFFFF'
  },
  '&.MuiLoadingButton-loading': {
    backgroundColor: '#0675DD',
    color: '#0675DD',
    '.MuiLoadingButton-loadingIndicator': {
      color: 'white'
    }
  }
});

export const SecondaryButton = styled(PrimaryButton)({
  backgroundColor: '#EBF3FA',
  border: '1px solid #EBF3FA',
  color: '#0259AB',
  '&:hover': {
    border: '1px solid #DDEBF7',
    backgroundColor: '#DDEBF7'
  },
  '&:disabled': {
    backgroundColor: '#f0f0f0',
    color: '#6a6a6a'
  },
  '&.MuiLoadingButton-loading': {
    backgroundColor: '#EBF3FA',
    color: '#EBF3FA',
    '.MuiLoadingButton-loadingIndicator': {
      color: '#FFFFFF'
    }
  }
});

export const LinkButton = styled(PrimaryButton)({
  fontSize: 14,
  fontWeight: 400,
  backgroundColor: 'transparent',
  border: 'none',
  color: '#0675DD',
  textDecoration: 'underline',
  '&:hover': {
    backgroundColor: 'transparent',
    textDecoration: 'underline',
    color: '#0675DD',
    border: 'none'
  }
});
